import $ from 'jquery'

export function exposeGlobally() {
  window.$ = window.jQuery = $
}